<template>
    <div v-if="!loadingPage" class="pb-2">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-primary mb-2">دسته‌بندی مواد اولیه</h3>
            <div v-if="isAdminIdentityVerified" class="d-flex justify-content-md-end justify-content-center mb-2">
                <b-button @click="showModalCreate" variant="primary" class="px-3">
                    ایجاد
                </b-button>
            </div>
        </div>
        <div v-if="isAdminIdentityVerified">
            <b-card v-if="categories.length" class="p-0" no-body>
                <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table responsive :items="categories" :fields="fields" class="mb-0" striped>
                        <template #cell(edit)="data">
                            <feather-icon @click="showModalEdit(data.item)" size="18" icon="EditIcon"
                                class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(description)="data">
                            <span v-if="data.item.description" v-b-popover.hover.top="data.item.description"
                                :title="data.item.name" class="text-info pointer">
                                <feather-icon icon="FileTextIcon" size="20" />
                            </span>
                            <span v-else>
                                -
                            </span>
                        </template>
                        <template #cell(createdAt)="data">
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new
                                    Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                            </span>
                        </template>
                        <template #cell(lastModifiedAt)="data">
                            <span>
                                {{ new Date(data.item.lastModifiedAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new
                                    Date(data.item.lastModifiedAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                            </span>
                        </template>
                    </b-table>
                </b-overlay>
            </b-card>
            <b-card v-else class="text-center py-5">
                موردی وجود ندارد
            </b-card>
            <b-pagination align="center" @input="getWarehousingCategories" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal create and edit ------------------------------->
        <b-modal id="warehousing-categories" :title="`${categoryMode}`" centered :hide-footer="true"
            title-class="font-weight-bolder" size="md">
            <div class="p-1">
                <validation-observer ref="warehousingCategoriesValidation">
                    <b-form @submit.prevent>

                        <!-- name -->
                        <b-form-group label="نام" label-for="nameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="nameId" v-model="form.name" name="name"
                                    class="text-center user-select-none" :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- description -->
                        <b-form-group label="توضیحات" label-for="descriptionId" class="text-center">
                            <b-form-textarea rows="2" no-resize autocomplete="off" dir="rtl" id="descriptionId"
                                v-model="form.description" name="description"></b-form-textarea>
                        </b-form-group>

                        <b-button type="submit" variant="primary" @click="managementCategories"
                            :disabled="loadingButton"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>{{ categoryMode }}</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>



    </div>
</template>

<script>
import { VBPopover, BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BBadge
    },
    directives: {
        'b-popover': VBPopover,
    },
    mixins: [accessHandling],
    data() {
        return {
            required,
            loadingPage: true,
            loading: false,
            loadingButton: false,
            isAdminIdentityVerified: false,
            categories: [],
            fields: [
                {
                    key: 'name',
                    label: 'نام',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ ایجاد',
                },
                {
                    key: 'lastModifiedAt',
                    label: 'تاریخ آخرین ویرایش',
                },
                {
                    key: 'description',
                    label: 'توضیحات',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null
            },
            storeId: null,
            form: {
                name: null,
                description: null,
            },
            categoryMode: null,
            categoryId: null,
        }
    },
    methods: {
        managementCategories() {
            if (this.categoryMode == 'ایجاد') {
                this.createWarehousingCategories()
            }
            if (this.categoryMode == 'ویرایش') {
                this.editWarehousingCategories()
            }
        },
        showModalEdit(item) {
            if (this.accessHandling('employee', 'warehouse_categories_materials_edit')) {
                this.categoryMode = 'ویرایش'
                this.categoryId = item.id
                this.form.name = item.name
                this.form.description = item.description
                this.$bvModal.show('warehousing-categories')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalCreate() {
            if (this.accessHandling('employee', 'warehouse_categories_materials_create')) {
                this.categoryMode = 'ایجاد'
                this.form.name = null
                this.form.description = null
                this.$bvModal.show('warehousing-categories')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        editWarehousingCategories() {
            this.$refs.warehousingCategoriesValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.editWarehousingCategories(this.storeId, this.categoryId, this.form).then(({ data }) => {
                        this.$refs.warehousingCategoriesValidation.reset();
                        this.$notif({ type: 'success', title: 'دسته‌بندی با موفقیت ویرایش شد' });
                        this.$bvModal.hide('warehousing-categories')
                        this.getWarehousingCategories()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        createWarehousingCategories() {
            this.$refs.warehousingCategoriesValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.warehousingCategories(this.storeId, this.form).then(({ data }) => {
                        this.$refs.warehousingCategoriesValidation.reset();
                        this.$notif({ type: 'success', title: 'دسته‌بندی با موفقیت ایجاد شد' });
                        this.$bvModal.hide('warehousing-categories')
                        this.getWarehousingCategories()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getWarehousingCategories();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getWarehousingCategories() {
            this.loading = true
            storeService.getWarehousingCategories(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.categories = data.items
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.categories = data.items
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getCompletionStatus()
    },
};
</script>